////////////////////////////////

import vmm_list   from '@/vmm-list/main'
import listconfig from './listconfig.js'

vmm_list.load( listconfig )

